import { isNil, negate, curry, equals } from 'lodash/fp'

export const getVal = snapshot => snapshot.val();

export const trace = value => {
    console.log(value);
    return value;
}

export const keyAsId = (value, key) => ({ ...value, id: key });

export const isNotNil = negate(isNil);

export const eqProps = curry(
    (field, object1, object2) => equals(object1[field], object2[field])
);

export const replaceUrlForHttps = url => url.replace("http://" , "https://");

export const isEqualArray = curry((predicate, array, otherArray) => {
    if(array.length !== otherArray.length){
        return false;
    }
    return array.every(item => otherArray.some(otherItem => predicate(item, otherItem)));
});

export * from './Chat';


// WEBPACK FOOTER //
// ./src/utils/index.js